window.resizeHomeSVGDivider = () => {
    const target = $('#home-svg-divider');
    target.css('minHeight', target.width() * 0.11);
};

$(() => {
    resizeHomeSVGDivider();
});
